export const applePaySupport = () => {
  try {
    return window.ApplePaySession && window.ApplePaySession.canMakePayments();
  } catch (e) {
    return false;
  }
};
